import fetch from "cross-fetch";
import { IAM_API_URL } from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import { navigate } from "../navigation/operations";

export function requestTokens(user_name, password, redirectTo) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.requestingAuth());
    return fetch(`${IAM_API_URL}/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_name: user_name,
        password: password
      })
    })
      .then(
        response => {
          if (response.status === 201) {
            return response.json();
          }
        },
        error => {
          dispatch(pushNotification("errors.iam.login", "error"));
          dispatch(ActionCreators.errorRequestingAuth(error));
        }
      )
      .then(json_response => {
        if (json_response) {
          dispatch(ActionCreators.receivedAuth(json_response.access_token, json_response.refresh_token));
          dispatch(pushNotification("success.iam.login", "success"));
          if (redirectTo) {
            dispatch(navigate(redirectTo));
          }
        } else {
          dispatch(pushNotification("errors.iam.login", "error"));
          dispatch(ActionCreators.errorRequestingAuth("errors.iam.login"));
        }
      });
  };
}

export function refreshTokens() {
  return function (dispatch, getState) {
    if (!getState().iam.accessToken) {
      return Promise.reject();
    }
    // dispatch(ActionCreators.requestingAuth());
    let request_options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getState().iam.refreshToken}`
      },
    }

    return fetch(`${IAM_API_URL}/auth/refresh`, request_options)
      .then(
        response => {
          if (response.status === 201 || response.status === 200) {
            return response.json();
          } else {
            dispatch(pushNotification("errors.iam.session_expired", "warning"));
            dispatch(ActionCreators.errorRequestingAuth(""));
          }
        },
        error => {
          dispatch(pushNotification("errors.iam.session_expired", "warning"));
          dispatch(ActionCreators.errorRequestingAuth(error));
        }
      )
      .then(json_response => {
        if (json_response) {
          dispatch(ActionCreators.refreshedToken(json_response.access_token));
          // dispatch(pushNotification("success.iam.login", "success"));

        } else {
          // dispatch(pushNotification("errors.iam.login", "error"));
          dispatch(ActionCreators.errorRequestingAuth("errors.iam.login"));
        }
      });
  };
}

export function register(payload, redirectTo, disableAutoLogin = false) {
    // {
  //   "u_name": "string",
  //   "f_name": "string",
  //   "l_name": "string",
  //   "pw": "string",
  //   "email": "string",
  //   "mobile_phone": "string",
  //   "description": "string",
  //   "address": "string",
  //   "country": "string",
  //   "city": "string",
  //   "lat": "string",
  //   "lon": "string",
  //   "image_url": "string",
  //   "base64_image": "string",
  //   "labels": [
  //     "string"
  //   ],
  //   "tags": [
  //     "string"
  //   ]
  // }
  return function (dispatch, getState) {
    dispatch(ActionCreators.creatingAccount());
    return fetch(`${IAM_API_URL}/user`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(
        response => {
          if (response.status === 201) {
            return response.json();
          } else {
            return { error: true, status: response.status };
          }
        },
        error => {
          dispatch(pushNotification("errors.iam.register", "error"));
          dispatch(ActionCreators.errorRequestingAuth(error));
        }
      )
      .then(json_response => {
        if (!json_response.error) {
          dispatch(ActionCreators.createdAccount());
          dispatch(pushNotification("success.iam.register", "success"));
          if (!disableAutoLogin) {
            return dispatch(requestTokens(payload.u_name, payload.pw, redirectTo));
          } else {
            if (redirectTo) {
              dispatch(navigate(redirectTo));
            }
          }
        } else {
          const error_message = json_response.status === 409 ? "errors.iam.register_duplicated" : "errors.iam.register";
          dispatch(pushNotification(error_message, "error"));
          dispatch(ActionCreators.errorRequestingAuth(error_message));
          return Promise.reject();
        }
      });
  };
}
